/**
 * Inline company logo for chart titles (next to the heading above the chart).
 */

export const COMPANY_LOGO_TITLE_SIZE = 39; // -10% from 43
export const COMPANY_LOGO_TITLE_SIZE_MOBILE = 33; // -10% from 37

/** Styles for an <img> sitting inline after/before a chart title. */
export function companyLogoTitleStyle(size = COMPANY_LOGO_TITLE_SIZE) {
  return {
    width: size,
    height: size,
    objectFit: "contain",
    flexShrink: 0,
    display: "block",
  };
}
